import { FC } from 'react'

import { Box, BoxProps, clsx } from '@mantine/core'

const FeatureCardContent: FC<BoxProps> = ({ children, className, ...rest }) => {
  return (
    <Box {...rest} className={clsx(className, 'card-content')}>
      {children}
    </Box>
  )
}

FeatureCardContent.displayName = 'FeatureCardContent'

export default FeatureCardContent
